import { memo } from 'react';
import type { CustomImage } from '../../types/customStoryblokComponents';
import StoryblokResponsiveImage from './StoryblokResponsiveImage';

const CustomImageComponent = memo((props: CustomImage) => {
    const width = props.customWidth || props.width;
    const height = props.customHeight || props.height;

    return (
        <StoryblokResponsiveImage
            style={{
                width: `${width}`,
                height: `${height}`,
            }}
            image={props.source}
        />
    );
});

export default CustomImageComponent;
